import { IconButton, Menu, MenuItem, Stack } from "@mui/material";
import { useState } from "react";
import { MoreVertRounded } from "@mui/icons-material";

const SmDynamicActions = (props: any) => {

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const open = !!anchorEl;

    function showInlineActions() {
        return (<Stack direction={"row"} justifyContent={"center"}>{props.children}</Stack>)
    }

    function showHamburgerActions() {
        return (
            <>
                <IconButton id={'hamburger-button'} onClick={(event) => setAnchorEl(event.currentTarget)}>
                    <MoreVertRounded/>
                </IconButton>
                <Menu id={'hamburger-menu'} anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
                    {props.children.map((it: any) => {
                        if (it !== false)
                            return <MenuItem key={it} onClick={() => setAnchorEl(null)}>{it}</MenuItem>
                        else
                            return <></>
                    })}
                </Menu>
            </>
        )
    }

    return (
        <>
            {(!Array.isArray(props.children) || props.children.length <= 2) ? showInlineActions() : showHamburgerActions()}
        </>
    )
}

export default SmDynamicActions